<template>
  <section class="section prospect-section">
    <div class="container is-max-desktop">
      <div class="box">
        <h1 class="title">Registro de prospectos</h1>
        <p class="mb-5">Comparte tus datos y elige la actividad que mejor representa a tu empresa. Nuestro equipo revisará la disponibilidad y te contactará.</p>
        <form @submit.prevent="submit">
          <div class="columns is-multiline">
            <b-field class="column is-6" label="Número de socio"><b-input v-model="form.socio" required /></b-field>
            <b-field class="column is-6" label="RFC"><b-input v-model="form.rfc" required @input="form.rfc = form.rfc.toUpperCase()" /></b-field>
            <b-field class="column is-6" label="Nombre"><b-input v-model="form.nombre" required /></b-field>
            <b-field class="column is-6" label="Apellido"><b-input v-model="form.apellido" required /></b-field>
            <b-field class="column is-6" label="Teléfono"><b-input v-model="form.telefono" required /></b-field>
            <b-field class="column is-6" label="Correo electrónico"><b-input v-model="form.email" type="email" required /></b-field>
            <b-field class="column is-6" label="Categoría"><b-select v-model="form.categoria_id" expanded required @input="form.subespecialidad_id = null"><option :value="null">Selecciona una categoría</option><option v-for="c in categorias" :key="c.id" :value="Number(c.id)">{{ c.nombre }}</option></b-select></b-field>
            <b-field class="column is-6" label="Subespecialidad"><b-select v-model="form.subespecialidad_id" expanded required :disabled="!form.categoria_id"><option :value="null">Selecciona una subespecialidad</option><option v-for="s in filteredSubs" :key="s.id" :value="Number(s.id)">{{ s.nombre }}</option></b-select></b-field>
            <div v-if="selectedSub" class="column is-12"><article class="message is-info"><div class="message-header"><p>{{ selectedSub.nombre }}</p></div><div class="message-body"><p><strong>Descripción:</strong> {{ selectedSub.descripcion_breve || 'Información no disponible.' }}</p><p class="mt-2"><strong>Ejemplos:</strong> {{ selectedSub.ejemplos_tipicos || 'No especificados.' }}</p><p class="mt-2"><strong>Palabras clave:</strong> {{ selectedSub.palabras_clave || 'No especificadas.' }}</p></div></article></div>
            <b-field class="column is-12" label="Nota o mensaje"><b-input v-model="form.mensaje" type="textarea" maxlength="1000" placeholder="Cuéntanos brevemente sobre tu empresa o actividad." /></b-field>
          </div>
          <b-button type="is-primary" native-type="submit" expanded :loading="loading">Enviar solicitud</b-button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import axiosInstance from '@/api/axiosInstance';
import Swal from 'sweetalert2';
export default {
  data: () => ({ categorias: [], subespecialidades: [], loading: false, form: { socio: '', rfc: '', nombre: '', apellido: '', telefono: '', email: '', categoria_id: null, subespecialidad_id: null, mensaje: '' } }),
  computed: {
    filteredSubs() { return this.subespecialidades.filter((s) => Number(s.categoria_id) === Number(this.form.categoria_id)); },
    selectedSub() { return this.subespecialidades.find((s) => Number(s.id) === Number(this.form.subespecialidad_id)); },
  },
  async mounted() { const response = await axiosInstance.get('/prospectos/catalogos'); this.categorias = response.data?.data?.categorias || []; this.subespecialidades = response.data?.data?.subespecialidades || []; },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const response = await axiosInstance.post('/prospectos/save', this.form);
        await Swal.fire({ icon: response.data.status ? 'success' : 'error', title: response.data.message || response.data.msg });
        if (response.data.status) this.form = { socio: '', rfc: '', nombre: '', apellido: '', telefono: '', email: '', categoria_id: null, subespecialidad_id: null, mensaje: '' };
      } finally { this.loading = false; }
    },
  },
};
</script>

<style scoped>.prospect-section { min-height: 100vh; background: #f7f7f7; }</style>
